import React from 'react';
import { usePlaytesterStore } from '../../stores/playtester-store.js';

export function WinOverlay() {
  const turnNumber = usePlaytesterStore((s) => s.turnNumber);
  const dismissOverlay = usePlaytesterStore((s) => s.dismissOverlay);

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/70">
      <div className="bg-gray-900 border border-green-600 rounded-xl p-8 flex flex-col items-center gap-6 max-w-md w-full mx-4 shadow-2xl">
        <div className="text-center">
          <h2 className="text-green-400 text-3xl font-bold mb-2">Horde Defeated!</h2>
          <p className="text-gray-300 text-lg">Survived {turnNumber} turn{turnNumber === 1 ? '' : 's'}</p>
        </div>

        <div className="flex flex-col gap-3 w-full">
          <button
            onClick={() => dismissOverlay('new-game')}
            className="w-full py-3 rounded-lg bg-green-700 hover:bg-green-600 text-white font-semibold text-base transition-colors"
          >
            New Game (Same Decks)
          </button>
          <button
            onClick={() => dismissOverlay('continue')}
            className="w-full py-2.5 rounded-lg bg-gray-700 hover:bg-gray-600 text-white font-medium text-sm transition-colors"
          >
            Continue Playing
          </button>
          <button
            onClick={() => dismissOverlay('return')}
            className="w-full py-2.5 rounded-lg bg-gray-800 hover:bg-gray-700 text-gray-300 font-medium text-sm transition-colors"
          >
            Return to Collection
          </button>
        </div>
      </div>
    </div>
  );
}
